var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6666 17.0625H6.66663C3.92913 17.0625 2.35413 15.4875 2.35413 12.75V5.25C2.35413 2.5125 3.92913 0.9375 6.66663 0.9375H12.6666C15.4041 0.9375 16.9791 2.5125 16.9791 5.25V12.75C16.9791 15.4875 15.4041 17.0625 12.6666 17.0625ZM6.66663 2.0625C4.52163 2.0625 3.47913 3.105 3.47913 5.25V12.75C3.47913 14.895 4.52163 15.9375 6.66663 15.9375H12.6666C14.8116 15.9375 15.8541 14.895 15.8541 12.75V5.25C15.8541 3.105 14.8116 2.0625 12.6666 2.0625H6.66663Z",
    fill: "#0A5EF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.41663 8.33249C7.28913 8.33249 7.16163 8.31001 7.04163 8.25751C6.69663 8.10751 6.47913 7.77 6.47913 7.4025V1.5C6.47913 1.1925 6.73413 0.9375 7.04163 0.9375H12.2916C12.5991 0.9375 12.8541 1.1925 12.8541 1.5V7.39499C12.8541 7.76999 12.6366 8.1075 12.2916 8.25C11.9541 8.4 11.5566 8.33251 11.2791 8.07751L9.66663 6.59999L8.05411 8.08502C7.87411 8.25002 7.64913 8.33249 7.41663 8.33249ZM9.66663 5.40752C9.89163 5.40752 10.1241 5.48998 10.3041 5.65498L11.7291 6.96748V2.0625H7.60413V6.96748L9.02914 5.65498C9.20914 5.48998 9.44163 5.40752 9.66663 5.40752Z",
    fill: "#0A5EF3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7916 11.0625H10.6041C10.2966 11.0625 10.0416 10.8075 10.0416 10.5C10.0416 10.1925 10.2966 9.9375 10.6041 9.9375H13.7916C14.0991 9.9375 14.3541 10.1925 14.3541 10.5C14.3541 10.8075 14.0991 11.0625 13.7916 11.0625Z",
    fill: "#0A5EF3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7916 14.0625H7.41663C7.10913 14.0625 6.85413 13.8075 6.85413 13.5C6.85413 13.1925 7.10913 12.9375 7.41663 12.9375H13.7916C14.0991 12.9375 14.3541 13.1925 14.3541 13.5C14.3541 13.8075 14.0991 14.0625 13.7916 14.0625Z",
    fill: "#0A5EF3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/document-icon.055e3c145fda1aede3afda8bb91e1322.svg";
export { ForwardRef as ReactComponent };